import React, { useEffect, useState } from 'react';
import AOS from 'aos';

import Navbar from '../../components/Navbar/Navbar.jsx';
import Hero from '../../components/Hero/Hero.jsx';
import Offerings from '../../components/Offerings/Offerings.jsx';


import Testimonials from '../../components/Testimonials/Testimonials.jsx';
import Contact from '../../components/Contact/Contact.jsx';
import Footer from '../../components/Footer/Footer.jsx';

import { AOS_CONFIG, SEO, WHAT_WE_DO } from './Home.js';
import './Home.css';

const Home = () => {
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    AOS.init(AOS_CONFIG);
    document.title = SEO.title;
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [expanded]);

  const displayItems = isMobile && !expanded
    ? WHAT_WE_DO.items.slice(0, 3)
    : WHAT_WE_DO.items;

  return (
    <main className="hm">
      <Navbar />
      <Hero />
      <Offerings/>
      <section className="hm__what-we-do rt__section">
        <div className="rt__container">
          <div className="hm__section-header" data-aos="fade-up">
            <h2 className="hm__section-heading">Experiences <span className="text-gradient">We Create</span></h2>
            <p className="hm__section-subheading">Tailored services that bring every journey to life.</p>
          </div>
          <div className="hm__what-we-do-grid">
            {displayItems.map((item, index) => (
              <div key={item.id} className="hm__what-we-do-card" data-aos="fade-up" data-aos-delay={(index % 3) * 100}>
                <h3 className="hm__what-we-do-title">{item.title}</h3>
                <p className="hm__what-we-do-desc">{item.description}</p>
              </div>
            ))}
          </div>
          {isMobile && WHAT_WE_DO.items.length > 3 && (
            <div className="hm__toggle-wrap">
              <button className="rt__btn rt__btn-primary hm__toggle-btn" onClick={() => setExpanded(!expanded)}>
                {expanded ? 'View Less' : 'View More'}
              </button>
            </div>
          )}
        </div>
      </section>
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
